import React from 'react';

const footer = () => {
    return (
        <footer>
          <div className="col">
            <span><i className="fa fa-github-square" aria-hidden="true"></i> <a href="https://github.com/jeanbarascu/movie-library" target="_blank" rel="noopener noreferrer">View Code</a></span>
          </div>
        </footer>
    );
};

export default footer;


// WEBPACK FOOTER //
// ./src/Footer/Footer.js